import type { FaireProductEntity } from "../../entity_types/product";

export const p_8295wzesuw: FaireProductEntity = {
  token: "p_8295wzesuw",
  type: "product",
  name: "Triple Fat Cacao Powder, 100% Cacao, Organic - Bulk Bag",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/d08329132f38b593982634f9308c6afcccfe2b7a9f784d38e383adc8592bca60.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/08ee903ea4408ee72ca90678438896316438cf71a1d4f5b7e0b0f720bed718fd.png",
    "https://cdn.faire.com/fastly/04b7cd066a05590d37799de93dda3b2cbda5fad254a8a03f40e8c3d50dab29c4.png",
  ],
  priceDollars: 85,
  description:
    "This cacao powder is a serious upgrade from what you can find in most stores. It's made from premium beans with 30% naturally occurring fat, which is three times the fat content of regular cacao powder. This is so important because the fat is essential for making the antioxidants and minerals in cacao bioavailable. \n\nThis cacao powder is direct trade and traceable to 200 individual farmers from a regenerative and organic project outside of Cusco, Peru. Many of the farms and the association are run by indigenous Koribeni and Kiteni women, who put their love and care into the stewardship of this cacao and the Amazon it calls home.\n\nIt's rich, decadent flavor makes it perfect for smoothies, baking, or hot chocolate. \nLab tested for heavy metals safety.\n\nNote: the bulk size is not packaged in tins. It comes in a bulk plastic bag.",
  tags: [],
  msrpDollars: 138.67,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:45.126Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
